import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import ShowPasswordIcon from "../../images/icons/ShowPasswordIcon.svg";
import { ContentStyle, DataGridListStyle } from "../../Theme";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import NoRecords from "../../components/NoRecords";
import PendingRefillsAlertsDetails from "./PendingRefillsAlertsDetails";
import { loadingRefillAlertsCount } from "../../Redux/Slice/RefillAlertsCountSlice";
import ErrorOverlay from "../../components/ErrorOverlay";
import { TextOnly } from "../../components/Content";

export default function PendingRefillsAlert(props: any) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [showFlow, setShowFlow] = useState(false);
  const [docId, setDocId] = useState("");
  const [docName, setDocName] = useState("");

  const columns: GridColDef[] = [
    {
      field: "doctorName",
      headerName: "Doctor",
      width: 350,
      cellClassName: "w40",
      headerClassName: "w40",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "prescriptionCount",
      headerName: "No of Prescriptions",
      width: 310,
      cellClassName: "w30",
      headerClassName: "w30",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w30",
      headerClassName: "w30",

      renderCell: ({ row }) => {
        return (
          <>
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={() => {
                  setShowFlow(true);
                }}
              >
                <img
                  src={ShowPasswordIcon}
                  alt="Show/Hide Password"
                  loading="lazy"
                />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const RefillAlertsCountState = useSelector((state: any) => {
    return { ...state.RefillAlertsCountSlice };
  }); //redux data
  const [rowCountState, setRowCountState] = useState(
    RefillAlertsCountState?.Pagination?.totalItems || 0
  );

  const dispatch = useDispatch();
  const PendingRefillAlertsCount = (nextPage: number) => {
    let paramsData = {
      pageNumber: nextPage,
      pageSize: pageSize,
    };
    dispatch(loadingRefillAlertsCount(paramsData));
  };

  useEffect(() => {
    PendingRefillAlertsCount(page);
  }, [page]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      RefillAlertsCountState?.Pagination?.totalItems !== undefined
        ? RefillAlertsCountState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [RefillAlertsCountState?.Pagination?.totalItems, setRowCountState]);
  return (
    <>
      <ContentStyle>
        <Grid container item xs={12} spacing={0} alignItems="top">
          <Grid item xs={12}></Grid>
          <Grid item xs={12} md={6}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Pending Refill Alerts
              <HelpGuideTooltip
                content={
                  <>
                    {" "}
                    <Typography component="div" variant="body1">
                      Refill-related alerts resulting from data discrepancies
                    </Typography>
                  </>
                }
              />
            </Typography>{" "}
          </Grid>

          {showFlow ? (
            <PendingRefillsAlertsDetails
              docId={docId}
              docName={docName}
              setShowFlow={setShowFlow}
            />
          ) : (
            <Grid item xs={12}>
              {" "}
              <DataGridListStyle>
                <DataGrid
                  rows={RefillAlertsCountState?.Items ?? []}
                  headerHeight={36}
                  sortingOrder={["desc", "asc"]}
                  columns={columns}
                  autoHeight
                  rowHeight={40}
                  pageSize={pageSize}
                  disableSelectionOnClick
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  paginationMode="server"
                  getRowId={() => uuid()}
                  loading={RefillAlertsCountState.isLoading}
                  components={{
                    NoRowsOverlay: NoRecords,
                    NoResultsOverlay: NoRecords,
                    ErrorOverlay: ErrorOverlay,
                  }}
                  error={RefillAlertsCountState?.error || undefined}
                  rowCount={rowCountState}
                  page={page}
                  rowsPerPageOptions={[pageSize]}
                  onRowClick={({ row }) => {
                    setShowFlow(true);
                    setDocId(row.doctorId);
                    setDocName(row.doctorName);
                  }}
                  onPageChange={(newPage) => {
                    setPage(newPage);
                  }}
                  getRowClassName={({ row }) => {
                    if (!row.onBehalf) {
                      return "PDoctor";
                    }
                    return "";
                  }}
                />
              </DataGridListStyle>
            </Grid>
          )}
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}
